import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useArchivedStrategyMemosInfiniteQueryKey } from './useArchivedStrategyMemosInfiniteQueryKey'

export const useInvalidateArchivedStrategyMemosInfiniteQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useArchivedStrategyMemosInfiniteQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
